const LEGISLATION_KEYS = [
    'reach',
    'scip',
    'rohs',
    'cbam',
    'pfas',
    'reach_a_17',
    'reach_a_14',
    'pops',
    'prop_65',
    'generic',
    'eu_cmr',
    'csrd',
    'fmv',
    'fcm',
    'ppwr',
]

const LEGISLATION_STATUSES = [
    'covered',
    'not_covered',
    'referenced',
]

const CLAIM_TYPES = [
    'compliant',
    'non_compliant',
    'substances_above_threshold',
    'no_substances_above_threshold',
    'substances_below_threshold',
    'contains_restricted_substances',
    'does_not_contain_restricted_substances',
    'has_exemptions',
    'no_exemptions',
    'has_scip_number',
]

export {
    CLAIM_TYPES,
    LEGISLATION_KEYS,
    LEGISLATION_STATUSES,
}
